module.exports = __webpack_public_path__ + "static/media/endosee-logo-pwa@3x.19b1d41f.jpg";